module.exports = __webpack_public_path__ + "static/img/logo_school_long.45170a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/logo_school_long.png
// module id = 617
// module chunks = 1